<script setup>
const route = useRoute();
const { data, error } = await useCmsFetch(`entry/pages/${route.params.slug}`);

if (error.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page Not Found",
    fatal: true,
  });
}

const { setGlobalTheme } = useTheme();
setGlobalTheme(data.value.theme);

useHead({
  title: data.value?.seoTitle + " | .the tech collective",

  meta: [
    { property: "og:title", content: data.value?.seoTitle },
    { name: "image", property: "og:image", content: data.value?.seoImage },
    { name: "description", content: data.value?.seoDescription },
    { name: "robots", content: data.value?.seoRobots },
  ],
  link: [
    {
      rel: "canonical",
      href: data.value?.seoCanonical || useRequestURL().href,
    },
  ].filter((item) => item.href),
});
</script>

<template>
  <div>
    <div v-if="data">
      <section-hero-standard
        :heading="data.heading || data.title"
        :body="data.body"
        :media="data.media"
        :horizontal-hero="data.horizontalHero"
        :cta="data.cta"
      />
      <component-sections v-if="data" :sections="data.sections" />
      <!-- <code>
        <pre>{{ data }}</pre>
      </code> -->
    </div>
  </div>
</template>
